export const getAdditionalContentStyles = (columns = 1) => ({
  gridColumn: `span ${columns}`,
});
